import { CheckmarkOutline16 } from '@carbon/icons-react';
import React from 'react';
import styled from 'styled-components';
import { StatusFieldOption } from 'api/tasks';
import { Color } from 'components/colors';
import { FullWidthCompletedTag } from '../../widgets/common';

const Tag = styled.div<{ color: Color; fullWidth?: boolean }>`
  background: ${(props) => `var(--${props.color}-60)`};
  border: 2px solid white;
  color: white;
  border-radius: 100px;
  width: 100%;
  padding: var(--spacing-03) var(--spacing-05);
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: var(--spacing-03);
  }
`;

export const CpCompletedTrigger: React.FC<{
  selectedOption: StatusFieldOption | undefined;
}> = ({ selectedOption }) => {
  return (
    <Tag color={selectedOption?.color ?? 'blue'}>
      <CheckmarkOutline16 />
      {selectedOption?.label}
    </Tag>
  );
};

export const CpFullWidthCompletedTrigger: React.FC<{
  selectedOption: StatusFieldOption | undefined;
}> = ({ selectedOption }) => {
  return (
    <FullWidthCompletedTag color={selectedOption?.color ?? 'blue'}>
      <CheckmarkOutline16 />
      <span className="status-label">{selectedOption?.label}</span>
    </FullWidthCompletedTag>
  );
};
